import Client from 'config/axios';

export const getBonusByAmbassador = async (
  token: string,
  limit: number,
  page: number
) => {
  const { data } = await Client.get(
    `bonus-by-ambassador?limit=${limit}&page=${page}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return {
    data
  };
};
